import React from 'react';
import MediaQuery from 'react-responsive';
import './CoCreation.css';

import topTriangles from '../../images/industry/top-triangles.png';
import innovationImg from '../../images/industry/imagemTrack.jpg';
import transferImg from '../../images/industry/imagemSiu.png';
import creationImg from '../../images/industry/imagemDark.png';
import consultancyImg from '../../images/industry/consultancy.jpg';
import unidadeEmbrapiiImg from '../../images/industry/logocompleta_embrapii.webp';

function CoCreationSection() {
  return (
    <div id="co-creation">
      <div id="top-banner">
        <img id="triangles" src={topTriangles} alt="" />
        <h2>
          Co-criamos
          <MediaQuery query="(min-width: 425px)">
            {' '}
          </MediaQuery>
          <MediaQuery query="(max-width: 425px)">
            <br />
          </MediaQuery>
          inovação baseada em tecnologia de ponta,
          gerando soluções disruptivas para o mercado.
        </h2>
      </div>

      <div id="colabs-container">
        <div id="colabs-collection">
          <div className="colabs-collection">

            <div className="ColabCont">
              <div className="imagem"><img src={innovationImg} alt="" /></div>
              <div className="ColabText">
                <h1>Inovação aplicada</h1>
                <h2>
                  Exploração de aplicações mais eficientes e eficazes
                  de tecnologias em soluções para o mercado através de mestrados e doutorados.
                </h2>
              </div>
            </div>

            <div className="ColabCont">
              <div className="imagem"><img src={transferImg} alt="" /></div>
              <div className="ColabText">
                <h1>Transferência tecnológica</h1>
                <h2>
                  Desenvolvimento e adaptação de tecnologias e plataformas do
                  nosso portfólio para atender à demandas do mercado.
                </h2>
              </div>
            </div>

            <div className="ColabCont">
              <div className="imagem"><img src={creationImg} alt="" /></div>
              <div className="ColabText">
                <h1>Criação de tecnologias</h1>
                <h2>
                  Desenvolvimento sob demanda para desafios específicos
                  de parceiros e clientes.
                </h2>
              </div>
            </div>

            <div className="ColabCont">
              <div className="imagem"><img src={consultancyImg} alt="" /></div>
              <div className="ColabText">
                <h1>Consultoria</h1>
                <h2>
                  Suporte e cobertura referente à transferência tecnológica,
                  descoberta de desafios e aplicações de tecnologias.
                </h2>
              </div>
            </div>

            <div className="linha" />

            <div className="ColabCont">
              <div className="imagem"><img id="logo_embrapii" src={unidadeEmbrapiiImg} alt="" /></div>
              <div className="ColabText">
                <h1>
                  Unidade Embrapii
                  {/* <span>Inovação em tecnologia veicular</span> */}
                </h1>
                <h2>
                  Unidade parceira da Embrapii, que fomenta e incentiva
                  projetos com a iniciativa privada envolvidos com
                  <span>Tecnologia Veicular</span>
                </h2>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default CoCreationSection;
